// extracted by mini-css-extract-plugin
export default {"nombre":"TablaClubNombres_nombre__CqZ7i","desde":"TablaClubNombres_desde__Apwgd","hasta":"TablaClubNombres_hasta__V2xtW"};